import BodyParser from '../util/request';

// API Google Maps JS (Google Cloud, na conta "celsinhorock@hotmail.com, em 'Minhas APIs, acesso 'Chaves e credenciais'")
const mapsApiKey = 'AIzaSyBaoZqsKTFbCEyIHCiy7gw48PmVgKqGQgk';

const mapsBaseUrl = 'https://maps.googleapis.com/maps/api';

const keyName = (types) => {
  if (types.includes('street_number')) {
    return 'numero';
  }
  if (types.includes('route')) {
    return 'endereco';
  }
  if (types.includes('sublocality')) {
    return 'bairro';
  }
  if (types.includes('locality') || types.includes('administrative_area_level_2')) {
    return 'cidade';
  }
  if (types.includes('administrative_area_level_1')) {
    return 'estado';
  }
  if (types.includes('country')) {
    return 'pais';
  }
  if (types.includes('postal_code')) {
    return 'cep';
  }
  return null;
};

// eslint-disable-next-line camelcase
const parseResultComponents = ({ place_id, ...result } = {}) => {
  if (!result || !result.address_components) {
    return null;
  }
  return result.address_components
    .reduce((obj, comp) => {
      const key = keyName(comp.types);
      return key
        ? { ...obj, [key]: comp.long_name }
        : obj;
      /* eslint-disable camelcase */
    }, { id: place_id });
};

export const fetchGoogleService = (data) => {
  const defaults = {
    key: mapsApiKey,
    language: 'pt-br',
  };

  const { serviceName, ...requestData } = data;

  const queryString = new BodyParser({
    ...defaults,
    ...requestData,
  }).toQueryString();

  const url = `${mapsBaseUrl}/${serviceName}/json?${queryString}`;

  return fetch(url)
    .then((resp) => (resp.ok ? resp.json() : { status: 'fail', ...resp }))
    .catch((error) => ({ status: 'fail', error }));
};

export const fetchPlaceDetails = (placeid) => fetchGoogleService({
  serviceName: 'place/details',
  placeid,
})
  .then(({ result, status }) => (
    typeof status === 'string'
    && status.toUpperCase() === 'OK'
    && parseResultComponents(result)
  ));

export const fetchGeocodeByCoords = (lat, lng) => fetchGoogleService({
  serviceName: 'geocode',
  latlng: `${lat},${lng}`,
})
  .then(({ results, status }) => (
    typeof status === 'string'
    && status.toUpperCase() === 'OK'
    && results.find(({ types }) => (
      types.includes('street_address')
    ))
  ))
  .then(parseResultComponents);

export const fetchCoordsByAddress = (address) => fetchGoogleService({
  serviceName: 'geocode',
  address,
})
  .then(({ results, status }) => (
    typeof status === 'string'
    && status.toUpperCase() === 'OK'
    && results[0]
  ))
  .then((res) => res && res.geometry && res.geometry.location);

export const fetchAutocomplete = (input, { latitude, longitude }) => fetchGoogleService({
  serviceName: 'place/autocomplete',
  location: `${latitude},${longitude}`,
  radius: 10000,
  types: 'address',
  input,
})
  .then(({ predictions, status }) => (
    typeof status === 'string'
    && status.toUpperCase() === 'OK'
    && predictions
  ));
